<a
	class="card-block copo-clickable"
	mat-ripple
	[routerLink]="['/guarantee-requests/card/', guarantee.id]"
>

	<!-- Title: project name (orange) + status -->
	<div class="order-tracking-list-card-header">
		<span class="guarantee-card-name">{{ guarantee.name }}</span>
		<div class="pill guarantee-card-status"
			[class.request-status-bg-draft]="isDraft(guarantee)"
			[class.request-status-bg-open]="isOpen(guarantee)"
			[class.request-status-bg-other]="isOther(guarantee)"
			[class.request-status-bg-satisfied]="isSatisfied(guarantee)"
			[class.request-status-bg-certificate-requested]="isCertificateRequested(guarantee)"
			[class.request-status-bg-certificate-issued]="isCertificateIssued(guarantee)"
			[class.request-status-bg-rejected]="isRejected(guarantee)"
			[class.request-status-bg-cancelled]="isCancelled(guarantee)"
			[class.request-status-bg-unknown]="isUnknown(guarantee)">
			<span class="guarantee-card-status-label">{{ getStatusLabel(guarantee) }}</span>
		</div>
	</div>

	<!-- Row 2: requested date + guarantee id -->
	<div class="order-tracking-list-card-informations-block">
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>guarantee.request.requested.date</span>
			<span class="order-card-value">{{ guarantee.requestDate ? (guarantee.requestDate | copoDate:'date') : UNDERSCORE }}</span>
		</div>
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>guarantee.request.id</span>
			<span class="order-card-value">{{ guarantee.guaranteeId ? guarantee.guaranteeId : UNDERSCORE }}</span>
		</div>
	</div>

	<!-- Row 3: type + author -->
	<div class="order-tracking-list-card-informations-block">
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>guarantee.request.type</span>
			<span class="order-card-value">{{ getLongType(guarantee.applicationType) }}</span>
		</div>
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>guarantee.request.author</span>
			<span class="order-card-value">{{ guarantee.requesterName ? guarantee.requesterName : UNDERSCORE }}</span>
		</div>
	</div>

</a>
